import Service from '@ember/service';

import { getOwner } from '@ember/owner'
import { once } from '@ember/runloop';
import { service } from '@ember/service';
import Handlebars from 'handlebars/dist/handlebars';

import { apiDownload } from 'rise-ui/utils/dynamic-node/helpers/api-download.js';
import { eachApiRequest } from 'rise-ui/utils/dynamic-node/helpers/each-api-request.js';
import { cFeatures } from 'rise-ui/utils/dynamic-node/helpers/c-features.js';
import { cFeature } from 'rise-ui/utils/dynamic-node/helpers/c-feature.js';
import { cFeatureTitle } from 'rise-ui/utils/dynamic-node/helpers/c-feature-title.js';
import { cFeatureImage } from 'rise-ui/utils/dynamic-node/helpers/c-feature-image.js';
import { cFeatureDescription } from 'rise-ui/utils/dynamic-node/helpers/c-feature-description.js';
// import { cNav } from 'rise-ui/utils/dynamic-node/helpers/c-nav.js';
import { cRoute } from 'rise-ui/utils/dynamic-node/helpers/c-route.js';
import { cUrl } from 'rise-ui/utils/dynamic-node/helpers/c-url.js';
import { link } from 'rise-ui/utils/dynamic-node/helpers/link.js';
import { p } from 'rise-ui/utils/dynamic-node/helpers/p.js';

export default class DynamicNodeService extends Service {
  @service ssr;
  @service store;

  constructor() {
    super(...arguments);
    const hb = this.handlebars = Handlebars.create();

    // Helpers
    hb.registerHelper('api-download', apiDownload);
    hb.registerHelper('each-api-request', eachApiRequest);
    hb.registerHelper('c-features', cFeatures);
    hb.registerHelper('c-feature', cFeature);
    hb.registerHelper('c-feature-title', cFeatureTitle);
    hb.registerHelper('c-feature-image', cFeatureImage);
    hb.registerHelper('c-feature-description', cFeatureDescription);
    // hb.registerHelper('c-nav', cNav);
    hb.registerHelper('c-route', cRoute);
    hb.registerHelper('c-url', cUrl);
    hb.registerHelper('link', link);
    hb.registerHelper('p', p);
  }

  compile(tpl) {
    const compiled = this.handlebars.compile((tpl || '') + '');
    return scope => {
      scope = this.createScope(scope);
      return { scope, html: compiled(scope) };
    };
  }

  createScope(scope = {}) {
    scope = {
      isSsr: this.ssr.isSsr,
      getOwner: () => getOwner(this),
      getDataKey: this.getDataKey,

      didInsertHandlers: {},
      setDidInsert(options, fn) {
        scope.didInsertHandlers[scope.getDataKey(options)] = fn;
      },
      didInsert(el) {
        for (const [ key, fn ] of Object.entries(scope.didInsertHandlers)) {
          fn?.(el, key);
        }
      },

      helperData: {},
      getHelperData(options) {
        return scope.helperData[scope.getDataKey(options)];
      },
      setHelperData(options, data, compile = true) {
        scope.helperData[scope.getDataKey(options)] = data;
        if (compile) {
          once(this, 'output');
        }
      },

      data: {},
      getNamedData(options) {
        return scope.data[scope.getDataKey(options)];
      },
      setNamedData(options, data, compile = true) {
        scope.data[scope.getDataKey(options)] = data;
        if (compile) {
          once(this, 'output');
        }
      },

      ...scope,
    };
    return scope;
  }

  getDataKey(options) {
    const {
      name,
      loc: {
        start: { column: sCol, line: sLine },
        end: { column: eCol, line: eLine }
      }
    } = options;
    return [ name, sCol, sLine, eCol, eLine ].join('.');
  }
}
